<template>
  <div class="menu-wrapper">
    <Button :config="{
              buttonText: props.config.buttonText,
              defaultEnabled: props.config.defaultEnabled,
              height: props.config.height,
              color: props.config.color
            }" @click="onToggleMenu" />
    <Menu :menuItems="[
      { label: 'File', text: $T('file_request', 'files_from_computer'), action: filePicker },
      { label: 'Folder', text: $T('file_request', 'folders_from_computer'), action: folderPicker },
    ]" ref="menuComponent" class="upload-menu" />
  </div>
</template>

<script setup>
import { ref } from 'vue'
import Button from './Button.vue'
import Menu from './Menu.vue'
import { $T } from '@/utils/texts'

const props = defineProps({
    config: Object,
  })

const menuComponent = ref(null)

const onToggleMenu = () => {
  menuComponent.value.isMenuVisible ? menuComponent.value.hideMenu() : menuComponent.value.showMenu()
}

const emit = defineEmits(['filePicker', 'folderPicker'])

const filePicker = () => {
  emit('filePicker')
}

const folderPicker = () => {
  emit('folderPicker')
}

</script>

<style scoped>
.menu-wrapper {
  position: relative;
}
.upload-menu {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}
</style>